import { defineCustomElement } from '../utils';
import { parseDataAttribute } from './utils';
export class Component extends HTMLElement {
    /**
     * The component's name.
     */
    name;
    /**
     * The component's props.
     */
    props;
    /**
     * Whether or not the component has been mounted.
     */
    mounted;
    constructor(name) {
        super();
        this.name = name;
        this.props = Object.entries(this.dataset).reduce((obj, [key, value]) => {
            return {
                ...obj,
                [key]: parseDataAttribute(value),
            };
        }, {});
        this.mounted = false;
    }
    /**
     * Called when the component is connected to the DOM.
     */
    // @ts-ignore
    connectedCallback() {
        if (!this.mounted) {
            this.mounted = true;
            this.componentDidMount();
            this.publish('mount');
        }
    }
    /**
     * Called when the component is disconnected from the DOM.
     */
    // @ts-ignore
    disconnectedCallback() {
        this.mounted = false;
        this.componentDidUnmount();
        this.publish('unmount');
    }
    /**
     * Called when the component is updated.
     */
    // @ts-ignore
    attributeChangedCallback(name, oldValue, newValue) {
        this.componentDidUpdate(name, oldValue, newValue);
    }
    /**
     * Called when the component is mounted. This is a wrapper around `connectedCallback`.
     */
    componentDidMount() { }
    /**
     * Called when the component is unmounted. This is a wrapper around `disconnectedCallback`.
     */
    componentDidUnmount() { }
    /**
     * Called when the component is updated. This is a wrapper around `attributeChangedCallback`.
     */
    // @ts-ignore
    componentDidUpdate(name, oldValue, newValue) { }
    validateProps(requiredProps) {
        requiredProps.forEach((prop) => {
            if (typeof this.props[prop] === 'undefined') {
                throw new Error(`Missing required prop: ${prop}`);
            }
        });
    }
    /**
     * Publishes a custom event on the component.
     */
    publish(event, data = null) {
        let namespacedEvent = this.name;
        if (this.props.action) {
            namespacedEvent += `[${this.props.action}]`;
        }
        namespacedEvent += '.';
        namespacedEvent += `${event}`;
        const customEvent = new CustomEvent(namespacedEvent, {
            detail: data,
            bubbles: true,
        });
        this.dispatchEvent(customEvent);
    }
}
/**
 * Defines a custom element.
 */
export function defineComponent(name, component) {
    defineCustomElement(name, component);
}
